import { render, staticRenderFns } from "./Disclosure.vue?vue&type=template&id=1e98a732&scoped=true&lang=pug&"
import script from "./Disclosure.vue?vue&type=script&lang=ts&"
export * from "./Disclosure.vue?vue&type=script&lang=ts&"
import style0 from "./Disclosure.vue?vue&type=style&index=0&id=1e98a732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e98a732",
  null
  
)

export default component.exports